import React from 'react';
import Button from '../Button/Button';
import Span from '../Texts/Span/Span';

const Buttons = ({ step, stepData, nextStep, endStep }) => {
  const buttons = {
    firststep: (
      <>
        <div>
          <Button size='md' onClick={nextStep}>
            {stepData.nextLabel || (
              <Span type='2' variant='white' align='center'>
                Iniciar el tutorial
              </Span>
            )}
          </Button>
        </div>
        <div>
          {stepData.skipButton &&
            (stepData.skipLabel || (
              <Button size='md' onClick={endStep} variant='none'>
                <Span type='4' variant='link' align='center'>
                  Omitir
                </Span>
              </Button>
            ))}
        </div>
      </>
    ),
    laststep: (
      <Button size='md' onClick={endStep}>
        {stepData.skipLabel || (
          <Span type='2' variant='white' align='center'>
            Finalizar
          </Span>
        )}
      </Button>
    ),
    middlestep: (
      <>
        <div>
          <Button size='md' onClick={nextStep}>
            <Span type='2' variant='white' align='center'>
              Siguiente
            </Span>
          </Button>
        </div>
        <div>
          {stepData.skipButton &&
            (stepData.skipLabel || (
              <Button size='md' onClick={endStep} variant='none'>
                <Span type='4' variant='link' align='center'>
                  Omitir
                </Span>
              </Button>
            ))}
        </div>
      </>
    ),
  };

  return buttons[step];
};

export default Buttons;
